import { Component, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@services/alert.service';
import { RegistrationDetails, RosterPatientService } from '@services/roster-patient.service';
import { Subject } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';

export interface RosteredDialogData {
  title: string;
  idName: string;
  rosteredName: string;
  explanation: string;
  client_code: string;
  diary_uuid: string;
}

@Component({
  selector: 'gc-roster-patient-dialog',
  templateUrl: './roster-patient-dialog.component.html',
  styleUrls: ['./roster-patient-dialog.component.scss'],
  standalone: false,
})
export class RosterPatientDialogComponent implements OnDestroy {
  rosterForm = this.formBuilder.group({
    patient_id: ['', Validators.required],
    roster_id: ['', Validators.required],
  });
  unsubscribe$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<RosterPatientDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: RosteredDialogData,
    private readonly alert: AlertService,
    private readonly formBuilder: FormBuilder,
    private readonly rosterPatientService: RosterPatientService,
    private readonly translateService: TranslateService,
  ) {}

  closeDialog() {
    this.alert.snackbar('patient_was_not_found_in_the_roster');
    this.dialogRef.close(false);
  }

  submit() {
    if (this.rosterForm.invalid) {
      this.rosterForm.markAllAsTouched();
      return;
    }
    this.rosterPatientService
      .getRosterPatient(this.rosterForm.value as RegistrationDetails, {
        client_code: this.data.client_code,
        diary_uuid: this.data.diary_uuid,
      })
      .pipe(
        catchError((err: unknown) => {
          this.alert.handleErrorDialog$(err, this.translateService.instant('error_getting_roster_patient'));
          throw err;
        }),
        takeUntil(this.unsubscribe$),
      )
      .subscribe((res) => {
        if (res.success) {
          this.alert.snackbar('patient_was_found_in_the_roster');
          return this.dialogRef.close(true);
        } else {
          this.closeDialog();
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
  }
}
